import { Http } from '@/lib/http';

export class AppService extends Http {
  constructor() {
    super();
  }

  getCountries() {
    return this.httpClient().get('/common/countries');
  }

  getCurrencies() {
    return this.httpClient().get('/common/currencies');
  }

  /**
   * Sends a request to get the qrCode for a logged in user
   */
  getQRCode() {
    return this.httpClient().get('/auth/2fa/generate');
  }

  /**
   * Verifies the token sent by the user
   *
   * Returns the new login data for the user
   */
  verifyToken(data) {
    return this.httpClient().post('/auth/2fa/authenticate', data);
  }

  /**
   * Used to switch the 2fa status of the user
   */
  toggle2fa(data) {
    return this.httpClient().post('/auth/2fa/toggle', data);
  }

  generateBackupCodes() {
    return this.httpClient().get('/auth/2fa/generate-backup-codes');
  }
}
